import {AfterViewInit, Component, Input, OnInit, Type, ViewChild, ViewContainerRef} from '@angular/core';
import {FlexSheetService} from "@features/spreadsheet/services/flex-sheet.service";
import {groupBy, GroupResult} from "@progress/kendo-data-query";
import {MagicLinkModel, TabModel} from "@shared/models/platform-tool-models";
import {RootDynamicComponentHelper} from "@shared/helpers/root-dynamic-component-helper";
import {ITooltipComponent} from "@shared/models/common.models";
import {ISideNoteComponent} from "@features/spreadsheet/models/footnote";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";

@Component({
    standalone: false,
    selector: 'app-foot-note-container',
  templateUrl: './side-note-container.component.html',
  styleUrls: ['./side-note-container.component.scss']
})
export class SideNoteContainerComponent implements OnInit, AfterViewInit {
  @Input() magicLinkModel: MagicLinkModel;
  @Input() selectedTab: TabModel;
  @Input() invalidateSubject: InvalidateSubject;
  @Input() componentName: string;
  @ViewChild('dynamicComponent', {read: ViewContainerRef, static: true}) viewContainerRef;
  constructor(private flexSheetService: FlexSheetService) { }

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    const resolvedComponent = <Type<any>>RootDynamicComponentHelper.getComponent(this.componentName);
    this.viewContainerRef.clear();
    const component = this.viewContainerRef.createComponent(resolvedComponent);
    const sideNoteComponent = component.instance as ISideNoteComponent;
    sideNoteComponent.magicLinkModel = this.magicLinkModel;
    sideNoteComponent.selectedTab = this.selectedTab;
    sideNoteComponent.invalidateSubject = this.invalidateSubject;
  }
}
